import { render, staticRenderFns } from "./TerminalConsulta.vue?vue&type=template&id=1900219a"
import script from "./TerminalConsulta.vue?vue&type=script&lang=js"
export * from "./TerminalConsulta.vue?vue&type=script&lang=js"
import style0 from "./TerminalConsulta.vue?vue&type=style&index=0&id=1900219a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports